import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { withLocalize } from 'react-localize-redux';
import ChatInput from './ChatInput';
import AiContextNudge from './AiContextNudge';
import PromptSuggestions from './PromptSuggestions';
import SingularLogo from '../../resources/svg/singular_logo_blue_figma.svg';
import usePromptSuggestions from '../hooks/usePromptSuggestions';
import { FOR_YOU_CATEGORY_ID } from '../promptLibrary';
import { CHAT_EVENTS, trackChatEvent } from '../constants';
import css from './ChatEmptyState.css';

const TRANSLATION_PREFIX = 'STATIC.PAGES.ANALYSIS_CHAT.EMPTY_STATE';

const ChatEmptyState = ({
    onSuggestionClick,
    input,
    handleInputChange,
    handleSubmit,
    isLoading,
    stop,
    onMicClick,
    isMicListening,
    micSupported,
    translate,
}) => {
    const { suggestions, isLoading: areSuggestionsLoading } = usePromptSuggestions();
    const composerRef = useRef(null);

    const onCardClick = ({ id, label, text, isPersonalized }) => {
        const category = isPersonalized ? FOR_YOU_CATEGORY_ID : id.split('.')[0];
        trackChatEvent(CHAT_EVENTS.SUGGESTION_CLICK, { suggestionTitle: label, category, isPersonalized });
        onSuggestionClick(text);
        composerRef.current?.focus();
    };

    return (
        <div className={css.chatEmptyState}>
            <div className={css.content}>
                <div className={css.greetingSection}>
                    <SingularLogo className={css.greetingLogo} />
                    <div className={css.greetingTitle}>{translate(`${TRANSLATION_PREFIX}.GREETING_TITLE`)}</div>
                </div>

                <div className={css.chatInputWrapper}>
                    <ChatInput
                        input={input}
                        handleInputChange={handleInputChange}
                        handleSubmit={handleSubmit}
                        isLoading={isLoading}
                        stop={stop}
                        onMicClick={onMicClick}
                        isMicListening={isMicListening}
                        micSupported={micSupported}
                        inputRef={composerRef}
                        containerClassName={css.chatInputInEmptyState}
                    />
                </div>

                <PromptSuggestions
                    personalized={suggestions}
                    isLoading={areSuggestionsLoading}
                    onPick={onCardClick}
                    translate={translate}
                />

                <AiContextNudge />
            </div>
        </div>
    );
};

ChatEmptyState.propTypes = {
    onSuggestionClick: PropTypes.func.isRequired,
    input: PropTypes.string.isRequired,
    handleInputChange: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    stop: PropTypes.func.isRequired,
    onMicClick: PropTypes.func,
    isMicListening: PropTypes.bool,
    micSupported: PropTypes.bool,
    translate: PropTypes.func.isRequired,
};

export default withLocalize(ChatEmptyState);
